<template>
  <div id="slider" style="width:100%;height:100%" class="w3-display-container"
    v-if="files.lenght != 0 && typeof files[slideIndex] != 'undefined'">
    <i class="fas fa-file-video imagen" style="font-size:5em"
      v-if="files[slideIndex].content_type && files[slideIndex].content_type.includes('video')"></i>
    <img
      v-if="files[slideIndex].filename.toLowerCase().includes('.png') || files[slideIndex].filename.toLowerCase().includes('.jpg') || files[slideIndex].filename.toLowerCase().includes('.bmp') || files[slideIndex].filename.toLowerCase().includes('.gif') || files[slideIndex].filename.toLowerCase().includes('.svg')"
      :src="url + '/resources/' + files[slideIndex]._id" class="imagen" />
    <img v-if="files[slideIndex].filename.toLowerCase().includes('.pdf')" src="../img/pdf.png" alt class="imagen" />
    <img
      v-if="files[slideIndex].filename.toLowerCase().includes('.xls') || files[slideIndex].filename.toLowerCase().includes('.xlsx') || files[slideIndex].filename.toLowerCase().includes('.xlt')"
      src="../img/xls.png" class="imagen" alt />
    <h1 class="h1" style="text-align:center;top:50%" v-if="noSoportado">
      {{ files[slideIndex].filename.toLowerCase().slice((files[slideIndex].filename.indexOf('.')) + 1, files[slideIndex].filename.length) }}
    </h1>
    <button class="w3-button w3-display-left flecha" @click="prev"
      v-if="files.length != 0 && files.length != 1">&#10094;</button>
    <button class="w3-button w3-display-right flecha" @click="next"
      v-if="files.length != 0 && files.length != 1">&#10095;</button>
  </div>
</template>
<script>
// import ws from "../config.json";
export default {
  name: "slider",
  props: {
    id: String
  },
  data() {
    return {
      files: [],
      slideIndex: 0,
      url: this.$store.getters.ws.api_recursos
    };
  },
  created: async function () {
    if (this.id != "null" && this.id != null) {
      this.files = await this.getDataSource(this.id);
    }
  },
  computed: {
    noSoportado() {
      if (
        this.files[this.slideIndex].filename &&
        this.files[this.slideIndex].content_type != null
      )
        return !(
          this.files[this.slideIndex].filename.toLowerCase().includes(".xls") ||
          this.files[this.slideIndex].filename
            .toLowerCase()
            .includes(".xlsx") ||
          this.files[this.slideIndex].filename.toLowerCase().includes(".xlt") ||
          this.files[this.slideIndex].filename.toLowerCase().includes(".pdf") ||
          this.files[this.slideIndex].content_type.includes("video") ||
          this.files[this.slideIndex].filename.toLowerCase().includes(".png") ||
          this.files[this.slideIndex].filename.toLowerCase().includes(".jpg") ||
          this.files[this.slideIndex].filename.toLowerCase().includes(".bmp") ||
          this.files[this.slideIndex].filename.toLowerCase().includes(".gif") ||
          this.files[this.slideIndex].filename.toLowerCase().includes(".svg")
        );
      else return this.files[this.slideIndex].content_type == null;
    }
  },
  methods: {
    async getDataSource(id) {

      let dataSource = [];

      await this.axios
        .get(this.$store.getters.ws.api_recursos + "/buckets/" + id + "/resources")
        .then(r => {
          r.data.content.forEach(e => {
            e.selected = false;
          });

          dataSource = r.data.content;
        })
        .catch(() => {
          return 0
        });

      return dataSource;

    },
    next: function () {
      // console.log(this.slideIndex);
      if (this.slideIndex + 1 >= this.files.length) {
        this.slideIndex = 0;
      } else {
        this.slideIndex += 1;
      }
    },
    prev: function () {
      // console.log(this.slideIndex);
      if (this.slideIndex - 1 <= -1) {
        this.slideIndex = this.files.length - 1;
      } else {
        this.slideIndex -= 1;
      }
    }
  }
};
</script>
<style>
.flecha {
  height: 15px;
  width: 15px;
  font-size: 10px;
  padding: 2px !important;
  background: black !important;
  color: white !important;
  border-radius: 25% !important;
}

#slider .imagen {
  height: 90px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(-50%);
}
</style>
